import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS';


const mapStateToProps = (state, ownProps) => ({
    locale: state.getIn(['translation', 'locale']),
    timezone: state.getIn(['translation', 'timezone']),
    debug: state.getIn(['translation', 'debug'])
})


const translationErrorLog = (debug, msg) => {
    if(debug) {
        console.error('TRANSLATION DATE ERROR: ' + msg)
    }
}


const TranslationDate = ({string, locale, timezone, debug, before="", after="", hasYear=false, hasWeekday=false}) => {
    let transString = 'Error'

    if(string && locale && timezone) {
        let dateOptions = {
            month: "numeric", 
            day: "numeric",
            timeZone: timezone
        }

        if(hasWeekday) {
            dateOptions.weekday = "short"
        }
        
        if(hasYear) {
            dateOptions.year = "numeric"
        }

        const dateObject = new Date(string)

        transString = dateObject.toLocaleDateString(locale, dateOptions)
    } else {
        translationErrorLog(debug, 'Date string, locale and timezone are requiered to display showtime')
    }

    if(before) {
        transString = before + transString
    }

    if(after) {
        transString = transString + after
    }

    return transString
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationDate)